import React from 'react';
import { Line } from 'react-chartjs-2';
import { options } from './util';
const CustomLineChart = ({ statsData, ystepSize, xAxis, yMax, yLabel, pointRadius }) => {
  return <Line data={statsData} options={options(xAxis, yLabel, ystepSize, yMax, pointRadius)} />;
};

export { CustomLineChart };
